@if (mockMode() !== MockMode.Off) {
  <button mat-button id="mock-config" (click)="showModalConfig()">
    <mat-icon>settings_input_component</mat-icon><span class="menu-label">Mock Configuration</span>
  </button>
}

<ng-template #modalMockConfig id="modalMockConfig">
  <div mat-dialog-title>Mock Configuration</div>
  <div mat-dialog-content>
    <div class="black-text">
      <div class="row">
        <div class="col s6">Server Mode</div>
        <div class="col s6">User Mode</div>
      </div>
      <div class="row">
        <div class="col s6">
          @for (mode of AllMockModes; track mode) {
            <div>
              <mat-radio-button
                name="serverMockRadio"
                [id]="'radio' + mode"
                [checked]="mode === mockMode()"
                (change)="setMockMode(mode)">
                {{ MockMode[mode] | translate: locale.language }}
              </mat-radio-button>
            </div>
          }
        </div>
        <div class="col s6">
          @for (mode of AllMockUserModes; track mode) {
            <div>
              <mat-radio-button
                name="userMockRadio"
                [id]="'radioUser' + mode"
                [checked]="mode === mockUserMode()"
                (change)="setMockUserMode(mode)">
                {{ MockUserMode[mode] | translate: locale.language }}
              </mat-radio-button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>
